import React from "react";
import HomeContent from "../content/public/HomeContent.jsx";

export default function HomePage() {
  return <HomeContent />;
}
